import classNames from "classnames";
import React, { FC } from "react";
import { useDrop } from "react-dnd";
import { COLUMN, COMPONENT, ROW, SIDEBAR_ITEM } from "../../config/constants";
import { ItemDNDType } from "../../utils/dndHelpers";
import "./dropzone.scss";

const ACCEPTS = [SIDEBAR_ITEM, COMPONENT, ROW, COLUMN];

export interface DropZoneProps {
  data: any;
  onDrop: any;
  checkDrop?:any;
  isLast?: boolean;
  className?: string;

}


const DropZone: FC<DropZoneProps> = ({ data, onDrop,checkDrop, isLast, className }) => {

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ACCEPTS,
    drop: (item: ItemDNDType, monitor) => {
      onDrop(data, item);
    },
    canDrop: (item: ItemDNDType, monitor) => {

      if(checkDrop){
        return checkDrop(item, monitor);
      }
      const dropZonePath = data.path;
      const splitDropZonePath = dropZonePath.split("-");
      const itemPath = item.path;

      // sidebar items can always be dropped anywhere
      if (!itemPath) {
        if (data.childrenCount >= 5) {
          return false;
        }
        return true;
      }

      const splitItemPath = itemPath.split("-");

      // limit columns when dragging from one row to another row
      const dropZonePathRowIndex = splitDropZonePath[0];
      const itemPathRowIndex = splitItemPath[0];
      const diffRow = dropZonePathRowIndex !== itemPathRowIndex;
      if (
        diffRow &&
        splitDropZonePath.length === 2 &&
        data.childrenCount >= 5
      ) {
        return false;
      }

      // Invalid (Can't drop a parent element (row) into a child (column))
      const parentDropInChild = splitItemPath.length < splitDropZonePath.length;
      if (parentDropInChild) return false;

      // Current item can't possible move to it's own location
      if (itemPath === dropZonePath) return false;

      // Current area
      if (splitItemPath.length === splitDropZonePath.length) {
        const pathToItem = splitItemPath.slice(0, -1).join("-");
        const currentItemIndex = Number(splitItemPath.slice(-1)[0]);

        const pathToDropZone = splitDropZonePath.slice(0, -1).join("-");
        const currentDropZoneIndex = Number(splitDropZonePath.slice(-1)[0]);

        if (pathToItem === pathToDropZone) {
          const nextDropZoneIndex = currentItemIndex + 1;
          if (nextDropZoneIndex === currentDropZoneIndex) return false;
        }
      }

      return true;
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const isActive = isOver && canDrop;
  return (
    <div
      className={classNames(
        "dropzone",
        { active: isActive, isLast },
        className
      )}
      ref={drop}
    />
  );
};
export default DropZone;
